import { TreeNode } from '../types';

/**
 * Build a lookup map from column name → display name by walking the tree.
 */
export function buildDisplayNameMap(nodes: TreeNode[]): Record<string, string> {
  const map: Record<string, string> = {};
  const walk = (nodeList: TreeNode[]) => {
    for (const node of nodeList) {
      if (node.metadata?.name) {
        map[node.metadata.name] = node.metadata.displayName || node.label;
      }
      if (node.children) {
        walk(node.children);
      }
    }
  };
  walk(nodes);
  return map;
}

/** Helper: get dimension data type from semantic model */
export function getDimDataType(dimName: string, semanticModel: any): string {
  if (!dimName || !semanticModel) return 'categorical';
  const dim = (semanticModel.dimensions || []).find((d: any) => d.name === dimName);
  if (!dim) return 'categorical';
  const t = dim.type?.toLowerCase();
  if (t === 'date' || t === 'datetime' || t === 'timestamp') return 'date';
  if (t === 'boolean') return 'boolean';
  if (t === 'integer' || t === 'number') return 'number';
  return 'categorical';
}

/** Helper: get enum values for a dimension from the physical model */
export function getEnumValues(dimName: string, semanticModel: any): string[] | null {
  if (!dimName || !semanticModel) return null;
  const dim = (semanticModel.dimensions || []).find((d: any) => d.name === dimName);
  if (!dim?.column) return null;
  const dotIndex = dim.column.indexOf('.');
  if (dotIndex < 0) return null;
  const tableName = dim.column.substring(0, dotIndex);
  const colName = dim.column.substring(dotIndex + 1);
  const table = semanticModel.physical?.tables?.[tableName];
  if (!table) return null;
  const colDef = (table.columns || []).find((c: any) => c.name === colName);
  if (!colDef?.values?.length) return null;
  return colDef.values;
}
